import { render } from "./LegalFooter.vue?vue&type=template&id=4d660734&scoped=true"
import script from "./LegalFooter.vue?vue&type=script&lang=js"
export * from "./LegalFooter.vue?vue&type=script&lang=js"

import "./LegalFooter.vue?vue&type=style&index=0&id=4d660734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d660734"]])

export default __exports__